import React from 'react';

import AtomOutline from '@/components/commons/icons/AtomOutline';
// import ChartMixedOutline from '@/components/commons/icons/ChartMixedOutline';
// import HouseSolid from '@/components/commons/icons/HouseSolid';
// import Briefcase from '@/components/commons/icons/Briefcase';
// import AdressBook from '@/components/commons/icons/AddressBook';
import UsersIcon from '@/components/commons/icons/Users';

export const statistics = [13, 79, 214, 15];
export const highlights = ['Julia Alesso-Kavanaugh', 'Marc Engalle', 'Michael Sansome', 'Gray Wincomb-Jones'];
const iconClasses = 'w-[14px]';
export const navData = [
    {
        label: 'Circles',
        value: 'circles',
        icon: <AtomOutline className={iconClasses} />,
    },
    // {
    //     label: 'Activity',
    //     value: 'activity',
    //     icon: <ChartMixedOutline className={iconClasses} />,
    // },
    // {
    //     label: 'Personal',
    //     value: 'personal',
    //     icon: <HouseSolid className={iconClasses} />,
    // },
    // {
    //     label: 'Professional',
    //     value: 'professional',
    //     icon: <Briefcase className={iconClasses} />,
    // },
    // {
    //     label: 'All contacts',
    //     value: 'all-contacts',
    //     icon: <AdressBook className={iconClasses} />,
    // },
    {
        label: 'Contacts game',
        value: 'contacts-game',
        icon: <UsersIcon className={iconClasses} />,
    },
];
